let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gv2np")).then(() => parcelRequire('6EPwW'));